<template>
  <div class="tab-content-inner">
    <!-- Provedor -->
    <div class="section-label">Provedor</div>

    <div class="provider-cards">
      <div class="provider-card active">
        <div class="provider-icon">
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M25.96 11.48C26.46 9.62 26.26 7.64 25.38 5.92C23.96 3.22 21.08 1.58 18.02 1.78C16.68 0.62 14.96 0 13.18 0C10.08 0 7.32 1.98 6.26 4.92C4.36 5.3 2.68 6.34 1.5 7.86C-0.28 10.32 -0.46 13.6 0.98 16.24C0.48 18.1 0.68 20.08 1.56 21.8C2.98 24.5 5.86 26.14 8.92 25.94C10.26 27.1 11.98 27.72 13.76 27.72C16.86 27.72 19.62 25.74 20.68 22.8C22.58 22.42 24.26 21.38 25.44 19.86C27.24 17.4 27.42 14.12 25.96 11.48ZM13.78 25.86C12.52 25.86 11.3 25.44 10.3 24.68L10.62 24.5L15.96 21.42C16.24 21.26 16.42 20.96 16.42 20.64V12.84L18.72 14.16C18.74 14.18 18.76 14.2 18.76 14.24V20.72C18.76 23.56 16.52 25.86 13.78 25.86ZM4.08 21.12C3.44 19.98 3.24 18.66 3.5 17.4L3.82 17.58L9.16 20.66C9.44 20.82 9.78 20.82 10.06 20.66L16.64 16.86V19.5C16.64 19.54 16.62 19.56 16.6 19.6L11.2 22.72C8.8 24.12 5.76 23.3 4.08 21.12ZM2.62 9.18C3.26 8.04 4.26 7.14 5.46 6.64V13.24C5.46 13.56 5.64 13.86 5.92 14.02L12.5 17.82L10.2 19.14C10.18 19.16 10.14 19.16 10.12 19.16L4.72 16.04C2.32 14.62 1.26 11.58 2.62 9.18ZM22.12 13.7L15.54 9.9L17.84 8.58C17.86 8.56 17.9 8.56 17.92 8.56L23.32 11.68C25.72 13.1 26.78 16.14 25.38 18.54C24.74 19.68 23.74 20.58 22.54 21.08V14.48C22.56 14.16 22.38 13.86 22.12 13.7ZM24.4 10.32L24.08 10.14L18.74 7.06C18.46 6.9 18.12 6.9 17.84 7.06L11.26 10.86V8.22C11.26 8.18 11.28 8.16 11.3 8.12L16.7 5C19.12 3.6 22.16 4.42 23.82 6.6C24.48 7.74 24.68 9.06 24.4 10.32ZM9.88 14.88L7.58 13.56C7.56 13.54 7.54 13.52 7.54 13.48V6.98C7.54 4.14 9.82 1.82 12.58 1.86C13.84 1.86 15.06 2.28 16.04 3.04L15.72 3.22L10.38 6.3C10.1 6.46 9.92 6.76 9.92 7.08L9.88 14.88ZM11.26 12.24L14 10.64L16.74 12.24V15.48L14 17.08L11.26 15.48V12.24Z" fill="#10A37F"/>
          </svg>
        </div>
        <div class="provider-info">
          <div class="provider-name">OpenAI GPT</div>
          <div class="provider-desc">Modelos GPT (4o, 4.1, 5)</div>
        </div>
      </div>
    </div>

    <div class="form-group">
      <label>Token API</label>
      <input
        type="text"
        class="form-control"
        :value="parametro.token"
        @input="update({ token: $event.target.value })"
        placeholder="Insira o token da API do provedor"
        autocomplete="off"
      />
    </div>

    <!-- Modelos -->
    <div class="section-label">Modelos</div>

    <div class="xrow">
      <div class="col-1-2">
        <div class="form-group">
          <label>Modelo Principal</label>
          <select
            class="form-control"
            :value="parametro.model"
            @change="update({ model: $event.target.value })"
          >
            <option value="">Selecione...</option>
            <option
              v-for="m in modelosDisponiveis.model"
              :key="m"
              :value="m"
            >
              {{ m }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-1-2">
        <div class="form-group">
          <label>Modelo Tunado (opcional)</label>
          <input
            type="text"
            class="form-control"
            :value="parametro.model_tunado"
            @input="update({ model_tunado: $event.target.value })"
            placeholder="Ex: ft:gpt-4o:my-org:custom-name:id"
          />
        </div>
      </div>
    </div>

    <div class="xrow">
      <div class="col-1-2">
        <div class="form-group">
          <label>Modelo para Áudio</label>
          <select
            class="form-control"
            :value="parametro.model_para_audio"
            @change="update({ model_para_audio: $event.target.value })"
          >
            <option value="">Selecione...</option>
            <option
              v-for="m in modelosDisponiveis.model_para_audio"
              :key="m"
              :value="m"
            >
              {{ m }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-1-2">
        <div class="form-group">
          <label>Modelo para Imagem</label>
          <select
            class="form-control"
            :value="parametro.model_para_imagem"
            @change="update({ model_para_imagem: $event.target.value })"
          >
            <option value="">Selecione...</option>
            <option
              v-for="m in modelosDisponiveis.model_para_imagem"
              :key="m"
              :value="m"
            >
              {{ m }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <!-- Busca -->
    <div class="section-label">Busca</div>

    <div class="form-group">
      <label>Itens para Análise</label>
      <input
        type="number"
        class="form-control"
        style="max-width: 200px"
        :value="parametro.itens_para_analise"
        @input="onItensParaAnaliseInput"
        min="1"
        max="50"
      />
      <small class="field-help">
        Quantidade de itens do catálogo enviados ao modelo de IA para análise
        de cada solicitação. Valores maiores aumentam a precisão das sugestões,
        mas elevam o tempo de resposta e o custo por requisição.
        <strong>Máximo: 50.</strong>
      </small>
      <small v-if="parametro.itens_para_analise > 30" class="field-warning">
        Valores acima de 30 podem causar lentidão perceptível e custos
        significativamente maiores por requisição.
      </small>
    </div>

    <div class="form-group">
      <label>Máximo de Tokens de Entrada</label>
      <input
        type="number"
        class="form-control"
        style="max-width: 200px"
        :value="parametro.max_tokens_entrada"
        @input="onMaxTokensEntradaInput"
        min="1000"
        max="200000"
      />
      <small class="field-help">
        Limita o tamanho dos dados enviados ao modelo de IA (1 token &asymp; 4 caracteres).
        Valores maiores permitem analisar mais dados, mas aumentam o custo e o tempo de resposta.
      </small>
      <small v-if="parametro.max_tokens_entrada > 100000" class="field-warning">
        Valores acima de 100.000 tokens podem gerar custos elevados por requisição.
      </small>
    </div>

    <!-- Callcenter -->
    <div class="section-label">Callcenter</div>

    <div class="toggles-card">
      <div class="toggle-row">
        <span class="toggle-row__label">
          Modo Aprendizado
          <small class="toggle-row__help">
            Permite que operadores corrijam termos de busca da IA diretamente na tela de sugestões
          </small>
        </span>
        <label class="toggle-switch">
          <input
            type="checkbox"
            :checked="!!parametro.modo_aprendizado"
            @change="update({ modo_aprendizado: $event.target.checked })"
          />
          <span class="toggle-slider"></span>
          <span class="toggle-text">{{ parametro.modo_aprendizado ? 'Sim' : 'Não' }}</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
const MODELOS = {
  model: [
    "gpt-5",
    "gpt-5-mini",
    "gpt-4.1",
    "gpt-4.1-mini",
    "gpt-4o",
    "gpt-4o-mini",
  ],
  model_para_audio: ["gpt-4o-transcribe", "gpt-4o-mini-transcribe"],
  model_para_imagem: ["gpt-4.1", "gpt-4.1-mini", "gpt-4o", "gpt-4o-mini"],
};

export default {
  name: "tab-provedor",
  props: {
    parametro: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    modelosDisponiveis() {
      return MODELOS;
    },
  },
  methods: {
    update(changes) {
      this.$emit("update", changes);
    },
    onItensParaAnaliseInput(event) {
      let val = parseInt(event.target.value) || 1;
      if (val < 1) val = 1;
      if (val > 50) val = 50;
      event.target.value = val;
      this.update({ itens_para_analise: val });
    },
    onMaxTokensEntradaInput(event) {
      let val = parseInt(event.target.value) || 1000;
      if (val < 1000) val = 1000;
      if (val > 200000) val = 200000;
      event.target.value = val;
      this.update({ max_tokens_entrada: val });
    },
  },
};
</script>

<style scoped>
.tab-content-inner {
  padding: 20px;
}

.section-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  color: #667085;
  letter-spacing: 0.5px;
  margin-bottom: 12px;
  margin-top: 20px;
}

.section-label:first-child {
  margin-top: 0;
}

.form-group {
  margin-bottom: 10px;
}

.provider-cards {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
}

.provider-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 18px;
  border: 1px solid #e4e7eb;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.15s ease;
  min-width: 220px;
}

.provider-card:hover {
  border-color: #dddce9;
  background: #f8f9fa;
}

.provider-card.active {
  border-color: #3a3e81;
  background: #eceaf3;
}

.provider-icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: #f2f2f8;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.provider-card.active .provider-icon {
  background: #fff;
}

.provider-name {
  font-weight: 600;
  font-size: 14px;
  color: #344054;
}

.provider-desc {
  font-size: 12px;
  color: #667085;
}

.field-help {
  display: block;
  margin-top: 6px;
  font-size: 12px;
  color: #667085;
  line-height: 1.5;
}

.field-warning {
  display: block;
  margin-top: 4px;
  font-size: 12px;
  color: #e65100;
  line-height: 1.5;
}

.xrow {
  display: flex;
  gap: 16px;
}

.col-1-2 {
  flex: 1;
}

.toggles-card {
  border: 1px solid #e4e7eb;
  border-radius: 10px;
  padding: 4px 16px;
}

.toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid #e9ecef;
}

.toggle-row:last-child {
  border-bottom: none;
}

.toggle-row__label {
  font-size: 13px;
  color: #333;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.toggle-row__help {
  font-size: 12px;
  color: #667085;
  font-weight: 400;
}

.toggle-switch {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  margin: 0;
  flex-shrink: 0;
}

.toggle-switch input {
  display: none;
}

.toggle-slider {
  position: relative;
  width: 36px;
  height: 20px;
  background-color: #ccc;
  border-radius: 20px;
  transition: background-color 0.2s;
}

.toggle-slider::after {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 16px;
  height: 16px;
  background-color: #fff;
  border-radius: 50%;
  transition: transform 0.2s;
}

.toggle-switch input:checked + .toggle-slider {
  background-color: #3a3e81;
}

.toggle-switch input:checked + .toggle-slider::after {
  transform: translateX(16px);
}

.toggle-text {
  font-size: 12px;
  color: #667085;
  min-width: 28px;
}
</style>
